import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type StoreAssetV2FragmentFragment = { __typename?: 'StoreAssetV2', id: string, creation_timestamp?: string | null, removed_at?: string | null, name: string, description?: string | null, internal_comment?: string | null, epc_tag: string, price?: number | null, is_billable?: boolean | null, is_recalled?: boolean | null, billing_start?: string | null, billing_end?: string | null, billing_frequency?: Types.BillingFrequency | null, billing_start_with_onboarding?: boolean | null, custom_fields: Array<{ __typename?: 'CustomFieldValue', id: string, name: string, type: Types.CustomFieldType, value?: string | null }>, item_type: { __typename?: 'ItemType', id: number, name: string, price?: number | null, category: Types.ItemTypeCategory, image_url?: string | null, color_hex_code?: string | null, custom_field_definitions?: Array<{ __typename?: 'CustomFieldDefinition', id: string, name: string, type: Types.CustomFieldType, required?: boolean | null, default_value?: string | null, depends_on?: { __typename?: 'CustomFieldDependency', field_id: string, value: string } | null }> | null } };

export const StoreAssetV2FragmentFragmentDoc = gql`
    fragment StoreAssetV2Fragment on StoreAssetV2 {
  id
  creation_timestamp
  removed_at
  name
  description
  internal_comment
  epc_tag
  price
  is_billable
  is_recalled
  billing_start
  billing_end
  billing_frequency
  billing_start_with_onboarding
  custom_fields {
    id
    name
    type
    value
  }
  item_type {
    id
    name
    price
    category
    image_url
    color_hex_code
    custom_field_definitions {
      id
      name
      type
      required
      default_value
      depends_on {
        field_id
        value
      }
    }
  }
}
    `;